import { Component, Input, ChangeDetectionStrategy } from '@angular/core'
import { FocusRemoverDirective } from '../../directives/focus-remover.directive'
import { RouterLink } from '@angular/router'
import { TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: '[appPreviewRow]',
  templateUrl: './preview-row.component.html',
  styleUrls: ['./preview-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FocusRemoverDirective, RouterLink, TranslatePipe]
})
export class PreviewRowComponent {
  @Input() title: string
  @Input() items?: any[]
  @Input() item?: string
  @Input() property?: string
  @Input() required?: boolean
  @Input() routerLinkOptions?: any[]

  constructor() {}
}
